/**
 * ระบบแปลงวันเวลาสำหรับประเทศไทย (Asia/Bangkok, UTC+7)
 * รูปแบบผลลัพธ์: YYYY-MM-DD :HH:mm (เช่น 2026-09-16 :12:30)
 */

export const formatThaiDateTime = (timestamp: string | number | Date | undefined | null): string => {
  if (!timestamp) return '-';

  try {
    if (typeof timestamp === 'string') {
      const trimmed = timestamp.trim();
      
      // กรณีเป็นรูปแบบ YYYY-MM-DD :HH:mm หรือ YYYY-MM-DD HH:mm อยู่แล้ว
      const matchExact = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})\s+:?(\d{2}):(\d{2})$/);
      if (matchExact) {
        return `${matchExact[1]}-${matchExact[2]}-${matchExact[3]} :${matchExact[4]}:${matchExact[5]}`;
      }

      // กรณีเป็นรูปแบบวันไทย/พ.ศ. เช่น "13/9/2569 20:39:40" หรือ "16/09/2569, 12:30"
      const matchBE = trimmed.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})(?:[,\s]+(\d{1,2}):(\d{1,2})(?::\d{1,2})?)?/);
      if (matchBE) {
        const day = matchBE[1].padStart(2, '0');
        const month = matchBE[2].padStart(2, '0');
        let yearNum = parseInt(matchBE[3], 10);
        if (yearNum > 2400) {
          yearNum -= 543; // แปลง พ.ศ. เป็น ค.ศ.
        }
        const hour = (matchBE[4] || '00').padStart(2, '0');
        const minute = (matchBE[5] || '00').padStart(2, '0');
        return `${yearNum}-${month}-${day} :${hour}:${minute}`;
      }
    }

    const d = new Date(timestamp);
    if (isNaN(d.getTime())) return String(timestamp);

    // ใช้ Intl.DateTimeFormat บังคับ Timezone เป็น Asia/Bangkok (ประเทศไทย UTC+7) เสมอ
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Bangkok',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });

    const parts = formatter.formatToParts(d);
    const getPart = (type: string) => parts.find((p) => p.type === type)?.value || '';

    let year = getPart('year');
    if (parseInt(year, 10) > 2400) {
      year = String(parseInt(year, 10) - 543);
    }
    const month = getPart('month').padStart(2, '0');
    const day = getPart('day').padStart(2, '0');
    let hour = (getPart('hour') || '00').padStart(2, '0');
    if (hour === '24') hour = '00';
    const minute = (getPart('minute') || '00').padStart(2, '0');

    if (!year || !month || !day) return String(timestamp);

    return `${year}-${month}-${day} :${hour}:${minute}`;
  } catch {
    return String(timestamp);
  }
};
